import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IResponse } from '../../../shared/data-access/models/response.models';
import { observe } from '../../../shared/utils/functions/observe.function';
import { Application } from '../models/application.model';
import { UserStore } from '../../../shared/data-access/stores/user.store';
import { ApplicantRequestedChanges } from '../models/requestedChanges.model';
import { FundAllocationsValidators } from '../../../admin/data-access/models/fundAllocations-model';
@Injectable({
  providedIn: 'root',
})
export class applicationService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(private http: HttpClient) {}
  private universitiesUrl = '/api/universities';
  private applicationsUrl = '/api/applications';
  private degreesUrl = '/api/degrees';
  private incompleteApplicationsUrl = '/api/incompleteApplications';
  private bursaryYearsUrl = '/api/bursaryYears';
  private renewalApplicationsUrl = '/api/applicationDueForRenewal';

  getUniversities(): Observable<IResponse<string[]>> {
    return observe(this.http.get<string[]>(this.universitiesUrl));
  }
  postApplication(data: Application[]): Observable<IResponse<number[]>> {
    return observe(
      this.http.post<number[]>(this.applicationsUrl, data, this.httpOptions),
    );
  }
  checkExistingStatus(data:Application[]):Observable<IResponse<Application[]>> {
    return observe(this.http.post<Application[]>(`/api/checkExistingApplication`, data,this.httpOptions)
  );
  }
  deleteApplication(applicationId: number) {
    return observe(
      this.http.delete<number>(`${this.applicationsUrl}/?id=${applicationId}`),
    );
  }
  getDegrees(): Observable<IResponse<string[]>> {
    return observe(this.http.get<string[]>(this.degreesUrl));
  }
  getAvailableBursaryYears(): Observable<IResponse<number[]>> {
    return observe(this.http.get<number[]>(this.bursaryYearsUrl));
  }

  getIncompleteApplications(isRenewal: boolean) {
    return observe(
      this.http.get<Application[]>(this.incompleteApplicationsUrl, { ...this.httpOptions, params: { isRenewal } })
    );
  }

  getRenewalApplications() {
    return observe(
      this.http.get<Application[]>(this.renewalApplicationsUrl, this.httpOptions)
    );
  }

  getUniversitiesHod():  Observable<IResponse<string[]>> {
    return observe(this.http.get<string[]>(`api/universities-HOD`));
  }

  getNumberOfApplications(): Observable<IResponse<number>> {
    return observe(this.http.get<number>(`api/numberOfApplications`));
  }

  updateApplication(
    applicationGuid: string,
    form: FormData
  ): Observable<IResponse<Application[]>> {
    const body = {
      applicationGuid,
       form
    };
    return observe(
      this.http.put<Application[]>(`api/updateApplications`, body),
    );
  }

  checkUser(email: string): Observable<IResponse<boolean>> {
    return observe(this.http.get<boolean>('api/check-user', {params: {email: email}}))
  }

  onboard(application:FormData): Observable<IResponse<string>> {
    return observe(this.http.post<string>('api/onboard', application));
  }

  getRequestedApplicationChanges(applicationGuid: string): Observable<IResponse<ApplicantRequestedChanges>> {
    return observe(this.http.get<ApplicantRequestedChanges>(`api/requested-application-changes/?applicationGuid=${applicationGuid}`));
  }

  updateRequestedApplicationFields(applicationUpdates:FormData, applicationGuid: string) {
    return observe(this.http.patch<string>(`api/update-student-application/?applicationGuid=${applicationGuid}`, applicationUpdates));
  }

  getStudentMinMaxAllocations(bursaryType: string):  Observable<IResponse<FundAllocationsValidators[]>> {
    return observe(this.http.get<FundAllocationsValidators[]>(`api/student-allocations-range/?bursaryType=${bursaryType}`));
  }
}
